import React, { useContext } from 'react';
export const HeadingContext = React.createContext(2);

function Section({
  as: Tag = 'section',
  ...props
}) {
  const level = useContext(HeadingContext);
  return React.createElement(HeadingContext.Provider, {
    value: level + 1
  }, React.createElement(Tag, props));
}

export default Section;